import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { cx } from "../cx";

export interface EmptyStateProps {
  icon: LucideIcon;
  title: ReactNode;
  body?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/** Centered icon, title, body and optional action (FE-02 FR-FE02-17). */
export function EmptyState({ icon: Icon, title, body, action, className }: EmptyStateProps) {
  return (
    <div className={cx("flex flex-col items-center gap-3 px-4 py-10 text-center", className)}>
      <span className="rounded-full bg-peach p-4 text-primary">
        <Icon aria-hidden="true" size={28} />
      </span>
      <p className="font-display text-lg font-bold">{title}</p>
      {body ? <p className="max-w-[40ch] text-text-muted">{body}</p> : null}
      {action}
    </div>
  );
}
